import { useT } from "../../../../../app/lib/i18n";
import * as s from "../../FilterBar.style.css";
import type { RangeQuickFilterConfig } from "../../FilterBar.types";
import type { QuickFilterVariant } from "../QuickFilterControl";

export interface RangeFilterProps {
  config: RangeQuickFilterConfig;
  value: unknown;
  onChange: (v: unknown) => void;
  variant?: QuickFilterVariant;
}

export function RangeFilter({ config, value, onChange, variant = "bar" }: RangeFilterProps) {
  const t = useT();
  const strValue = (value as string) ?? "";
  const isModal = variant === "modal";
  return (
    <div className={isModal ? s.quickFiltersModalFilterRow : s.quickFilterItem}>
      <label
        htmlFor={`filter-${config.id}`}
        className={isModal ? s.quickFiltersModalLabel : s.quickFilterLabel}
      >
        {config.label}:
      </label>
      <select
        id={`filter-${config.id}`}
        className={isModal ? s.quickFiltersModalSelect : s.quickFilterSelect}
        value={strValue}
        onChange={(e) => onChange(e.target.value || undefined)}
      >
        <option value="">{t("shared.filter.all")}</option>
        {config.options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
